import { VideoContext } from "../Player.js";

type WTOListener = () => void;


export enum WhenTimeOccursPolicy {
    ALWAYS = 0,
    ON_PLAYING = 1
}
export class WhenTimeOccurs {

    private lastTime: number;
    private remaining: number[]; 
    private conditionMap: Map<number,WTOListener[]>;

    private _tickListener: () => void;

    constructor(private videoContext: VideoContext, private tickPolicy: WhenTimeOccursPolicy) {
        this.lastTime = 0;
        this.conditionMap = new Map<number,WTOListener[]>();
        this.remaining = [];
        const tickl = () => this.tick();
        this._tickListener = tickl;
        videoContext.on("timeupdate",tickl);
    }



    private tick() {
        if(this.tickPolicy == WhenTimeOccursPolicy.ALWAYS || (this.tickPolicy == WhenTimeOccursPolicy.ON_PLAYING && !this.videoContext.isPaused)) {
            const time = Math.floor(this.videoContext.currentTime);
            if(time > this.lastTime  && (time - this.lastTime) >= 1) {
                const [toProcess,newRemaining] =  predicateSplitter(this.remaining,(a) => a <= time);
                this.remaining = newRemaining;
                toProcess.forEach(k => {
                    const listeners = this.conditionMap.get(k)
                    listeners.forEach(lst => lst());
                    this.conditionMap.delete(k);
                })
                
            }
        }
    }

    public whenTimeIsAfter(time: number, listener: () => void) {
        let key = Math.floor(time);
        key = Math.max(key,0);
        let existing = this.conditionMap.get(key);

        if(!existing) {
           existing = [];
           this.conditionMap.set(key,existing); 
           this.remaining.push(key);
           this.remaining = this.remaining.sort((a,b) => a - b);
        }
        existing.push(listener);
    }   


    public destroy() {
        this.videoContext.off("timeupdate",this._tickListener);
    }
}


function predicateSplitter<A>(arr: A[], pred: (a: A) => boolean): [A[],A[]] {

    let i = 0;
    if(arr.length > 0) {
        while(pred(arr[i])) { i++; }
    }
    if(i <= 0) {
        return [[],arr];
    }
    else {
        return [arr.slice(0,i),arr.slice(i)];
    }

}